import React from "react";
import { TAddressForm } from "@/features/clients/create/types";
import { TextField } from "mui-rff";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const AddressForm = ({ required }: TAddressForm): any => {
    const { t } = useTranslation();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} >
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_street')}
                    name="address_calle"
                    required={required.calle}
                />

            </Grid>
            <Grid item xs={12} md={2}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_ext_num')}
                    name="address_no_exterior"
                    required={required.no_exterior}
                />
            </Grid>
            <Grid item xs={12} md={2}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_int_num')}
                    name="address_no_interior"
                    required={required.no_interior}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_colony')}
                    name="address_colonia"
                    required={required.address_colonia}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_street_reference')}
                    name="address_referencia"
                    required={required.address_referencia}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_municipality')}
                    name="address_municipio"
                    required={required.address_municipio}
                />

            </Grid>


            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_locality')}
                    name="address_localidad"
                    required={required.address_localidad}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_state')}
                    name="address_estado"
                    required={required.address_estado}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t('clients.label_zip_code')}
                    name="address_codigo_postal"
                    required={required.address_codigo_postal}
                />
            </Grid>

        </Grid>





    );
}

export default AddressForm;
